<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-card>
        <v-container fluid class="pa-5">
          <v-row>
            <v-col cols="12">
              <p>Your Preferred Stocks (Summary of your liked stocks)</p>
            </v-col>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left">RIC</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Days to Trade</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in listLikes" :key="i">
                      <td>
                        <v-btn
                          class="px-2 mr-2"
                          color="info"
                          min-width="0"
                          icon
                          small
                          @click="goToStock(item[0])"
                        >
                          <v-icon>
                            mdi-magnify-plus-outline
                          </v-icon>
                        </v-btn>
                      </td>
                      <td>{{ item[0] }}</td>
                      <td>{{ item[1] }}</td>
                      <td>{{ item[4] }}</td>
                      <td>
                        <v-btn
                          @click="removeLikedDislikedStock(item[0])"
                          class="px-2 ml-1"
                          outlined
                          min-width="0"
                          small
                        >
                          <v-icon small>
                            mdi-delete
                          </v-icon>
                          Delete
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn outlined class="mr-0" @click="addRowLikeDislike(true)">
                <v-icon left>mdi-plus</v-icon> Add Stock
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>

    <v-col cols="12" md="6">
      <v-card>
        <v-container fluid class="pa-5">
          <v-row>
            <v-col cols="12">
              <p>Your Disliked Stocks</p>
            </v-col>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left">RIC</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Days to Trade</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in listDislikes" :key="i">
                      <td>
                        <v-btn
                          class="px-2 mr-2"
                          color="info"
                          min-width="0"
                          icon
                          small
                          @click="goToStock(item[0])"
                        >
                          <v-icon>
                            mdi-magnify-plus-outline
                          </v-icon>
                        </v-btn>
                      </td>
                      <td>{{ item[0] }}</td>
                      <td>{{ item[1] }}</td>
                      <td>{{ item[4] }}</td>
                      <td>
                        <v-btn
                          @click="removeLikedDislikedStock(item[0])"
                          class="px-2 ml-1"
                          outlined
                          min-width="0"
                          small
                        >
                          <v-icon small>
                            mdi-delete
                          </v-icon>
                          Delete
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn outlined class="mr-0" @click="addRowLikeDislike(false)">
                <v-icon left>mdi-plus</v-icon> Add Stock
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>

    <v-col cols="12" md="6">
      <v-card>
        <v-container fluid class="pa-5">
          <v-row>
            <v-col cols="12">
              <p>You Might Like</p>
            </v-col>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left">RIC</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Implied Rating</th>
                      <th class="text-left">Days to Trade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in mightLike" :key="i">
                      <td>
                        <v-btn
                          class="px-2 mr-2"
                          color="info"
                          min-width="0"
                          icon
                          small
                          @click="goToStock(item[0])"
                        >
                          <v-icon>
                            mdi-magnify-plus-outline
                          </v-icon>
                        </v-btn>
                      </td>
                      <td>{{ item[0] }}</td>
                      <td>{{ item[1] }}</td>
                      <td>
                        <star-rating
                          :rating="item[5]"
                          :padding="5"
                          inactive-color="#e1bad9"
                          active-color="#cc1166"
                          :increment="0.01"
                          :star-size="20"
                          :inline="true"
                          :show-rating="false"
                          :read-only="true"
                        ></star-rating>
                      </td>
                      <td>{{ item[4] }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>

    <v-col cols="12" md="6">
      <v-card>
        <v-container fluid class="pa-5">
          <v-row>
            <v-col cols="12">
              <p>You Might Dislike</p>
            </v-col>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left">RIC</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Implied Rating</th>
                      <th class="text-left">Days to Trade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in mightDislike" :key="i">
                      <td>
                        <v-btn
                          class="px-2 mr-2"
                          color="info"
                          min-width="0"
                          icon
                          small
                          @click="goToStock(item[0])"
                        >
                          <v-icon>
                            mdi-magnify-plus-outline
                          </v-icon>
                        </v-btn>
                      </td>
                      <td>{{ item[0] }}</td>
                      <td>{{ item[1] }}</td>
                      <td>
                        <star-rating
                          :rating="item[5]"
                          :padding="5"
                          inactive-color="#e1bad9"
                          active-color="#cc1166"
                          :increment="0.01"
                          :star-size="20"
                          :inline="true"
                          :show-rating="false"
                          :read-only="true"
                        ></star-rating>
                      </td>
                      <td>{{ item[4] }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>

    <v-dialog v-model="addStockDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Select a stock</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="model"
                  :items="stockItems"
                  :loading="isLoadingDialog"
                  :search-input.sync="searchStock"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="ric"
                  placeholder="Search stock"
                  prepend-icon="mdi-magnify"
                  solo
                  :filter="customFilter"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Search for
                        <strong>stock</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template>

                  <template v-slot:item="{ item }">
                    <v-list-item @click="selectStockItem(item)">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.name"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="
                            item.ric +
                              '  |  ' +
                              item.ticker +
                              '  |  ' +
                              item.isin
                          "
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon>mdi-magnify</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    listLikes: {
      type: Array,
      default: () => []
    },
    listDislikes: {
      type: Array,
      default: () => []
    },
    mightLike: {
      type: Array,
      default: () => []
    },
    mightDislike: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    stockAddLikeOrDislike: null,
    model: null,
    stockItems: [],
    searchStock: "",
    addStockDialog: false,
    isLoadingDialog: true
  }),
  watch: {
    searchStock() {
      this.isLoadingDialog = true;
      this.getSearchFromApi(this.searchStock);
    }
  },
  methods: {
    async getSearchFromApi(search) {
      const vm = this;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .post(
          process.env.VUE_APP_API_HOST + "/get-stocks-search",
          { filter: search },
          {
            headers: {
              Authorization: currentToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          //console.log(response.data);
          vm.stockItems = response.data;
        })
        .catch(function(err) {
          //console.log(err);
          return (err);
        })
        .finally(() => (vm.isLoadingDialog = false));
    },
    customFilter(item, queryText, itemText) {
      const textOne = itemText ? itemText.toLowerCase() : "";
      const textTwo = item.ric ? item.ric.toLowerCase() : "";
      const textThree = item.ticker ? item.ticker.toLowerCase() : "";
      const textFour = item.isin ? item.isin.toLowerCase() : "";
      const searchText = queryText ? queryText.toLowerCase() : "";

      return (
        textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1 ||
        textThree.indexOf(searchText) > -1 ||
        textFour.indexOf(searchText) > -1
      );
    },
    removeLikedDislikedStock(symbol) {
      this.$emit("remove-liked-disliked-stock", symbol);
    },
    goToStock(id) {
      this.$router.push({ name: "StocksAnalyze", params: { stock: id } });
    },
    addRowLikeDislike(isLike) {
      //console.log("addRowLikeDislike");
      this.addStockDialog = true;
      this.stockAddLikeOrDislike = isLike;
    },
    selectStockItem(item) {
      //console.log(item);
      if (this.stockAddLikeOrDislike) {
        this.$emit("add-liked-stock", item.ric);
      } else {
        this.$emit("add-disliked-stock", item.ric);
      }
    }
  }
};
</script>